export default __webpack_public_path__ + "static/media/Soulrender's Mark.9ea718f9.jpg";